import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>INTRODUCTION</div>
                                            <p>We’ve all been doing it for long enough – since the moment we
                                                were born, in fact – but most of us are not as good at it as we
                                                think we are. In psychological terms, listening is a ‘cognitive
                                                process’ – it involves thought, attention and awareness. It’s
                                                the conscious mental process of giving meaning to the sounds we
                                                hear and ‘contextualising’ them. In other words, we interpret
                                                sounds in relation to other factors, including circumstance,
                                                emotion or habit.</p>
                                            <div className="browncontentbg uiheading keyquestionpad">
                                                <p>It is said that ‘we have two ears but only one mouth because
                                                    listening is twice as hard as talking!’</p>
                                            </div>
                                            <br/>

                                                <p>Even so, many of us are still just pretending. Think about
                                                    some of the conversations you’ve had which were more a
                                                    matter of taking turns to speak, which is ironic,
                                                    considering how much we all want to be listened to and
                                                    understood!</p>
                                                <p>While we can speak at 100 to 175 words per minute, we’re able
                                                    to listen intelligently at up to 300 words per minute.<a
                                                        className="superscripttext"
                                                        href="further_info.php?course=300"><sup>4</sup></a> As
                                                    we all know, and doubtless find useful on occasion, this
                                                    means we can ‘listen’ and think about all sorts of other
                                                    things at the same time. However, ‘listening with one ear’
                                                    means that only part of our minds are paying attention,
                                                    which is less useful and could be problematic, if it becomes
                                                    habitual. This is where ‘active listening’ comes in – the
                                                    difference is that it’s <span className="subtiltereg">listening with a purpose.</span>
                                                </p>
                                                <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                    <span className="heading">WHAT IS ACTIVE LISTENING?</span>
                                                </div>

                                                <p>Active listening is a structured way of listening and
                                                    responding to others in a way that improves mutual
                                                    understanding, by focusing attention on the speaker. Its
                                                    intent is to ‘listen for meaning’ and the listener checks
                                                    with the speaker to ensure statements are correctly heard
                                                    and understood.</p><p>In situations of conflict, people tend
                                                to concentrate more on what they are going to say next, than on
                                                listening to what’s being said, which can mean they ‘miss the
                                                point’ of what is being said, adding misunderstanding or
                                                frustration to the interaction, rather than understanding or
                                                resolution.</p>
                                                <div className="lightgreencontentbg keyquestionpad">
                                                    <ul className="greenbullet-list">
                                                        <div className="border_subtitle">Active listening
                                                            constitutes three elements:
                                                        </div>
                                                        <li>Hearing – the process of capturing sound waves and
                                                            sending this data to the brain.
                                                        </li>
                                                        <li>Interpreting – as information is received, the brain
                                                            interprets the data according to previous
                                                            experience, learning and other influences.
                                                        </li>
                                                        <li>Assigning a contextual meaning – the brain gives
                                                            ‘heard’ data specific meaning, according to
                                                            situation or circumstance.
                                                        </li>
                                                    </ul>
                                                </div>


                                                <div className="left-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page1')}
                                                        className="button-next-previous-done">&lt;&lt; Previous
                                                    </div>
                                                </div>
                                                <div className="right-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page3')}
                                                        className="button-next-previous-done">Next &gt;&gt;</div>
                                                </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }